import {
    USER_LOGOUT, FETCH_CONTRACTORS,
} from "actions/actionTypes";
var _ = require('lodash');

const initialState = {data: [], fetched: false, total: 'initial', selectedContractors:[]};
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_CONTRACTORS:
            console.log(FETCH_CONTRACTORS, action.payload.data);
            return {
                ...state,
                data: action.payload.data,
                total: action.payload.total,
                fetched: true
            }


        // case ADD_SELECTED_CONTRACTORS:
        // console.log('ADD_SELECTED_CONTRACTORS', state,  action.payload);
        // var selectedContractorsToAdd =_.map( action.payload, function (contractor) {
        //     return contractor._id;
        // });
        // var updatedSelectedContractors = _.uniq(state.selectedContractors.concat(selectedContractorsToAdd));
        // return {
        //     ...state,
        //     selectedContractors: updatedSelectedContractors
        // }
        // case CLEAR_SELECTED_CONTRACTORS:
        //     console.log('CLEAR_SELECTED_CONTRACTORS', state,  action.payload);
        //     return {
        //         ...state,
        //         selectedContractors: []
        //     }
        // case REMOVE_SELECTED_CONTRACTORS:
        //     console.log('REMOVE_SELECTED_CONTRACTORS', state,  action.payload);
        //     var selectedContractorsToRemove =_.map( action.payload, function (contractor) {
        //         return contractor._id;
        //     });
        //     var updatedSelectedContractors =  _.uniq(_.difference(state.selectedContractors, selectedContractorsToRemove));
        //     console.log('updatedSelectedContractors', updatedSelectedContractors);
        //
        //     return {
        //         ...state,
        //         selectedContractors: updatedSelectedContractors,
        //     }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
// Get record by id
export const getContractor = (state, id) => {
    return state.adminContractors.data.filter(record => record._id === id)[0];
}


